<template>
  <el-select
    v-model="selectedId"
    @change="doChange"
    :placeholder="placeholder"
    :size="size"
    @click.prevent.stop=""
    :filterable="true"
  >
    <el-option
      v-for="option in callerIds"
      :value="option.id"
      :key="option.id"
      :label="option.label"
      @click.prevent.stop=""
    >
      <!-- TODO add label color -->
    </el-option>
  </el-select>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'callerIdSelect',
  computed: {
    ...mapGetters('phoneNumbers', ['getCallerIds']),
    ...mapGetters('auth', ['getLoginAccount', 'getGlobalBrandIds']),
    ...mapGetters('team', ['getUserById']),
  },
  emits: ['update:callerId'],
  props: {
    initialId: {
      type: Number,
      default: () => undefined,
    },
    size: {
      type: String,
      default: () => 'small',
    },
    placeholder: {
      type: String,
      required: false,
      default: () => 'Select a Caller Id',
    },
    allowAll: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      selectedId: undefined,
      callerIds: [],
    };
  },
  watch: {
    value(n) {
      this.selectedIndex = parseInt(n);
    },
    initialId(n) {
      this.selectedId = parseInt(n);
    },
    getGlobalBrandIds() {
      this.setCallerIds();
    },
  },
  async created() {
    this.setCallerIds();
    if (this.initialId) {
      this.selectedId = parseInt(this.initialId);
      return;
    }
    // Set default if initial is not defined
    const defaultId = this.getUserById(this.getLoginAccount.userId).from_voice_id;
    const found = this.callerIds.find((c) => c.id == defaultId);
    if (found) {
      this.selectedId = found.id;
      this.doChange();
    }
  },
  methods: {
    doChange(event) {
      const num = this.getCallerIds.find((c) => c.id == this.selectedId);
      this.$emit('update:callerId', num ? num.id : undefined);
    },
    setCallerIds() {
      if (this.getGlobalBrandIds && this.getGlobalBrandIds.length) {
        this.callerIds = this.getCallerIds.filter(c => this.getGlobalBrandIds.includes(c.brand_id));
      }
      else {
        this.callerIds = this.getCallerIds;
      }
    },
  },
};
</script>

